<template>
  <view>
    <text>about</text>
  </view>
</template>

<script>
export default {
  name: 'index',
};
</script>

<style scoped></style>
